import React from 'react';
import {
  Tag,
  Text,
  Box,
  Grid,
  GridItem,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
} from '@chakra-ui/react';
import xhr from 'xhr';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import ReplayModal from './ReplayModal';
import FormLiveClasses from './formLiveClasses';
import useAuth from 'hooks/useAuth';
import ClassRecurrent from './Class-recurrent';

function SubirClases() {
  let [searchParams] = useSearchParams();
  const [liveClasses, setLiveClasses] = React.useState([]);
  const [semester, setSemester] = React.useState([]);
  const [live, setLive] = React.useState([]);
  const [fetching, isFetching] = React.useState(true);
  const [reload, setReload] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenRecurrent, setIsOpenRecurrent] = React.useState(false);

  const { user } = useAuth();

  // Nombre de la materia actual (la lista puede traer compartidas de otras materias).
  const ownClass =
    liveClasses.find((el) => String(el.subject?.id) === String(searchParams.get('subject'))) || liveClasses[0];

  React.useEffect(() => {
    const getLiveClasses = async () => {
      try {
        let res;

        if (user?.school) {
          res = await xhr(
            `/live-classes?filters[subject][id][$eq]=${searchParams.get('subject')}&filters[school][id][$eq]=${user?.school?.id}&sort[0]=start_date:DESC&populate=*&pagination[limit]=-1`
          );
        } else {
          // Propias de la materia + las compartidas hacia ella desde otro programa.
          const subject = searchParams.get('subject');
          res = await xhr(
            `/live-classes?filters[$or][0][subject][id][$eq]=${subject}&filters[$or][1][other_subjects][id][$eq]=${subject}&sort[0]=start_date:DESC&populate=*&pagination[limit]=-1`
          );
        }

        setLiveClasses(res.data.data);
        setReload(false);
      } catch (error) {
      } finally {
        isFetching(false);
      }
    };
    getLiveClasses();
  }, [reload]);

  React.useEffect(() => {
    const getSemester = async () => {
      try {
        const semUrl = user?.school?.id
          ? `/semesters?sort[0]=id:DESC&filters[school][id][$eq]=${user.school.id}`
          : `/semesters?sort[0]=id:DESC&filters[$or][0][school][id][$null]=true&filters[$or][1][school][id][$eq]=0`;
        const res = await xhr(semUrl);
        setSemester(
          res.data.data.map((el) => {
            return { ...el, label: el.name, value: el.name };
          })
        );
      } catch (error) {
      } finally {
        isFetching(false);
      }
    };
    getSemester();
  }, []);

  return (
    <>
      <Modal
        isOpen={isOpen}
        size="3xl"
        onClose={() => {
          setIsOpen(false);
          setLive('');
          setReload(false);
        }}
        motionPreset="scale"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <ReplayModal
              setLive={setLive}
              live={live}
              semester={semester}
              reload={reload}
              setReload={setReload}
              setIsOpen={setIsOpen}
              user={user}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenRecurrent} onClose={() => setIsOpenRecurrent(false)} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Crear reunión recurrente</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <ClassRecurrent
              semester={semester}
              setReload={setReload}
              title={ownClass?.course ? ownClass?.course.name : ownClass?.subject?.name}
              user={user}
              setIsOpen={setIsOpenRecurrent}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Grid templateColumns="repeat(2, 1fr)" gap={5}>
        <GridItem>
          <Box border="1px solid #cac9c9" borderRadius="10px" p="15px">
            <Text fontSize="28px" fontWeight="bold">
              Crear clase en vivo (
              {ownClass?.course ? ownClass?.course?.name : ownClass?.subject?.name})
            </Text>

            {!user?.school && (
              <Box marginTop="20px" mb="15px">
                <Button
                  colorScheme="#574feb"
                  bg="#574feb"
                  color="white"
                  onClick={() => setIsOpenRecurrent(true)}
                >
                  Reunión recurrente
                </Button>
              </Box>
            )}

            <Box marginTop="20px">
              <FormLiveClasses
                live={live}
                semester={semester}
                title={ownClass?.course ? ownClass?.course.name : ownClass?.subject?.name}
                setReload={setReload}
                reload={reload}
                user={user}
              />
            </Box>
          </Box>
        </GridItem>

        <GridItem border="1px solid #cac9c9" borderRadius="10px" p="15px">
          <Text fontSize="28px" fontWeight="bold">
            Clases en vivo creadas
          </Text>

          <TableContainer>
            <Table marginTop="35px">
              <Thead bg="gray.200">
                <Tr>
                  <Th>Titulo</Th>
                  <Th textAlign="right">Fecha</Th>
                </Tr>
              </Thead>
              <Tbody>
                {liveClasses.map((live) => {
                  return (
                    <Tr key={live.id}>
                      <Td>
                        <Button
                          onClick={() => {
                            setIsOpen(true);
                            setLive(live);
                          }}
                        >
                          {live.title}
                        </Button>
                        {String(live.subject?.id) !== String(searchParams.get('subject')) ? (
                          <Tag ml="8px" size="sm" colorScheme="purple">
                            Compartida desde {live.subject?.name}
                          </Tag>
                        ) : (live.other_subjects || []).length > 0 ? (
                          <Tag ml="8px" size="sm" colorScheme="purple">
                            Compartida · {live.other_subjects.length} programa(s)
                          </Tag>
                        ) : null}
                      </Td>
                      <Td textAlign="right">
                        {dayjs(live.start_date).format('MMM-DD-YYYY hh:mm A')}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </GridItem>
      </Grid>
    </>
  );
}

export default SubirClases;